const config = {
  restUrl: (path, version) => {
    let host = 'https://re.stol.it/api/rest/'
    version = version ? version : 'v1'
    if (process.env.RAZZLE_API_HOST) host = process.env.RAZZLE_API_HOST

    //remove double slashes
    path = path.replace(/^\//, '')
    return host + version + '/' + path
  },
  baseUrl: (path) => {
    let host = '/'

    //remove double slashes
    path = path.replace(/^\//, '')
    return host + path
  },
  authUrl: (path) => {
    let host = process.env.RAZZLE_API_AUTHENTICATION_HOST
    if (host === undefined) {
      host = 'https://www.stol.it/oauth/'
    }

    //remove double slashes
    path = path.replace(/^\//, '')
    return host + path
  },
  geoUrl: (path) => {
    let host = 'https://nominatim.openstreetmap.org/reverse?format=json'

    //remove double slashes
    path = path.replace(/^\//, '')
    return host + path
  },
}

module.exports = config
